<template>
  <v-dialog persistent v-model="dialog" max-width="350px">
    <v-card>
      <v-card-title>
        {{ $t("components.tableColumnSelector.title") }}
      </v-card-title>
      <v-container>
        <v-list>
          <v-list-item-group multiple v-model="selectedColumns">
            <v-list-item v-for="column in headers" :key="column.value">
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    color="primary"
                    :value="column.visible"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ column.text }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="onClose">
          {{ $t("button.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Array,
    show: { type: Boolean, default: false },
    skip: Array
  },
  data: () => ({
    dialog: false,
    selectedColumns: []
  }),
  computed: {
    headers() {
      return this.value.filter(e => !this.skip.includes(e.value));
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      }
    }
  },
  methods: {
    onClose() {
      const length = this.value.length;
      for (let i = 0; i < length; i++) {
        this.value[i].visible = this.selectedColumns.includes(i);
      }
      this.dialog = false;
      this.$emit("hide");
      this.$emit("input", this.value);
    }
  },
  mounted() {
    const length = this.value.length;
    for (let i = 0; i < length; i++) {
      if (this.value[i].visible) {
        this.selectedColumns.push(i);
      }
    }
  }
};
</script>

<style scoped></style>
